import React, { Component, Fragment } from 'react'
import { Loader, Modal, Button, Div, H2, Span } from '@driftt/tide-core'
import { Table } from '@driftt/tide-table'
import { Select } from '@driftt/tide-selects'
import { showTransientNotification } from '@driftt/traffic-control'
import { connect } from 'react-redux'

import { getPeopleInCampaign, unenrollUser } from 'api/campaigns'
import { getMeetingAgents, getPersonInPlaybookDetails } from 'api/playbooks'
import { peopleColumns, filterableMetrics } from 'constants/ReportConstants'
import Paginator from './Paginator'
import { find, propEq, pathOr } from 'ramda'
import RowFormatter from 'components/Reports/EmailPerformance/TableRowFormatter'
import { EmptyTable } from 'components/Reports/EmailPerformance/EmptyState'

import './styles.css'

const LOADING_STATE = {
  hasLoaded: false,
  isLoading: true,
}

class CampaignPeopleTab extends Component {
  constructor(props) {
    super(props)

    this.state = {
      size: 20,
      currentPage: 0,
      tableData: null,
      isLoading: true,
      hasLoaded: false,
      pageParams: [],
      page: null,
      metric: { label: 'All Activity', value: null },
      email: null,
      isUnenrolling: false,
      unenrollingEmail: null,
    }
  }

  componentDidMount() {
    this.getEmailPeople()
  }

  componentWillReceiveProps() {
    this.setState({
      hasLoaded: false,
      isLoading: true
    }, this.getEmailPeople)
  }

  getEmailPeople = async () => {
    const { id, dates } = this.props
    const [ startDate, endDate ] = dates
    const { size, page, metric, email } = this.state

    try {
      const { data } = await getPeopleInCampaign(id, Object.assign({ startDate, endDate, size }, page && {page}, !!metric.value && { metric: metric.value }, !!email && { emailId: email.value }))
      this.setState({
        tableData: data
      }, this.getEndUsers)
    } catch (error) {
      console.log(error)
    }
  }

  getNumPages = () => {
    const numItems = this.getNumItems()
    const pageSize = this.state.size
    return Math.ceil(numItems/pageSize)
  }

  getNumItems = () => {
    const pageNum = this.state.currentPage + 1
    const pageSize = this.state.size
    const remaining = this.state.tableData.remaining
    const currentPageLength = this.state.tableData.people.length
    return currentPageLength + (pageNum-1)*pageSize + remaining
  }

  getEndUsers = async () => {
    const { tableData } = this.state
    const endUsers = tableData.people.map((endUser) => {
      return endUser.endUserId
    })

    try {
      const { data } = await getPersonInPlaybookDetails(endUsers)
      this.setState({
        endUsers: data
      }, this.getAgents)
    } catch (error) {
      console.log(error)
    }
  }

  getAgents = async () => {
    const { tableData } = this.state

    if (!tableData.people) {
      return
    }

    const agentList = this.getAgentsFromData(tableData.people)

    try {
      const { data } = await getMeetingAgents(agentList)
      this.setState({
        agents: data
      }, this.setHasLoaded)
    } catch (error) {
      console.log(error)
    }
  }

  getAgentsFromData(data) {
    return data
      .filter(user => user.influencedBookedMeeting || user.sentFrom)
      .map(user => [user.influencedBookedMeetingAgentId, user.sentFrom])
      .flatten()
      .filter(id => !!id)
  }

  setHasLoaded = () => {
    this.setState({
      hasLoaded: true,
      isLoading: false
    })
  }

  goToNext = () => {
    const { tableData } = this.state
    const { nextPage } = tableData

    this.setState((prevState) => {
      prevState.pageParams.push(nextPage)
      return {
        hasLoaded: false,
        isLoading: true,
        currentPage: prevState.currentPage + 1,
        pageParams: prevState.pageParams,
        page: nextPage
      }
    }, this.getEmailPeople)
  }

  goToPrevious = () => {
    this.setState((prevState) => {
      prevState.pageParams.pop()

      return {
        hasLoaded: false,
        isLoading: true,
        currentPage: prevState.currentPage - 1,
        pageParams: prevState.pageParams,
        page: prevState.pageParams[prevState.pageParams.length - 1]
      }
    }, this.getEmailPeople)
  }

  setPageSize = ({ value }) => (
    this.setState({
      size: value,
      currentPage: 0,
      page: null,
      pageParams: [],
      hasLoaded: false,
      isLoading: true
    }, this.getEmailPeople)
  )

  unenrollUserApi = async (person) => {
    const { email, playbookId } = person
    const { endUsers } = this.state
    const { currentUserId } = this.props
    const endUserToUnenroll = find(propEq('email', email))(endUsers)
    const manualUnenrollPayload = {
      endUserId: endUserToUnenroll.id,
      emailCampaignId: playbookId,
      unenrolledById: currentUserId,
    }
    try {
      await unenrollUser(manualUnenrollPayload)
      this.props.notify('User successfully unenrolled!')
    } catch (e) {
      this.props.notify('Could not unenroll, please try again later', 'error')
      console.log(e)
    }
  }

  unenrollUser = (person) => {
    this.setState({
      isUnenrolling: true,
      unenrollingPerson: person,
    })
  }

  onUnenrollClick = (person) => {
    this.unenrollUserApi(person)

    this.setState({
      isUnenrolling: false,
      unenrollingPerson: null
    })
  }

  onCancelClick = () => {
    this.setState({
      isUnenrolling: false,
      unenrollingPerson: null
    })
  }

  handleMetricFilterChange = (option) => {
    if (!!option) {
      this.setState({ metric: option, ...LOADING_STATE }, this.getEmailPeople)
    } else {
      this.setState({ metric: { label: 'All Activity', value: null }, ...LOADING_STATE }, this.getEmailPeople)
    }
  }

  handleEmailFilterChange = (option) => {
    if (!!option) {
      this.setState({ email: option, ...LOADING_STATE }, this.getEmailPeople)
    } else {
      this.setState({ email: null, metric: { label: 'All Activity', value: null }, ...LOADING_STATE }, this.getEmailPeople)
    }
  }

  makeEmailFilterOptions() {
    const { campaign: { emails } } = this.props
    return emails.map((email, index, { length: numEmails }) => (
      {
        value: email.id,
        label: numEmails > 1 ? `Email ${index + 1} : ${email.subjectLine}` : email.subjectLine,
      }
    ))
  }

  renderTableOrEmptyState() {
    const { tableData, endUsers, agents } = this.state
    const { people } = tableData
    const noPeople = people.length === 0
    const { campaign } = this.props
    return (
      <Fragment>
        {noPeople ? 
          <Div className="reports-people-no-matches">
            <EmptyTable />
            <H2>No results matching your filters</H2>
          </Div> :        
          <Div className="reports-people-table-container horizontal-mask">
            <Table 
                className="reports-people-table" 
                width="2250px"
                columns={peopleColumns}
                data={!!tableData ? people.map((person) => RowFormatter.PeopleRows(person, endUsers, agents, campaign, this.unenrollUser)) : []}
            />
          </Div>
        }
      </Fragment>
    )
  }

  render() {
    const {
      isLoading,
      hasLoaded,
      size,
      currentPage,
      metric,
      email,
      isUnenrolling,
      unenrollingPerson,
    } = this.state


    const metricOptions = Object.entries(filterableMetrics).map(([key, value]) => ({ value, label: key }))

    if (hasLoaded && !email) {
      this.setState({
        email: this.makeEmailFilterOptions()[0]
      })
    }

    return (
      <Div className="playbooks-report-people">
        {isLoading &&
          <Div className="playbook-report-loader">
            <Loader height={200} width={200} />
          </Div>
        }
        {hasLoaded &&
          <Fragment>
            <Div className="reports-people-header">
              <Div className="reports-people-header-total-count">
                <Span>{`${this.getNumItems()} People`}</Span>
                <Span className="reports-people-header-selects">
                  {email &&
                    <Select
                      className="reports-people-select-metric"
                      value={metric}
                      onChange={this.handleMetricFilterChange}
                      isClearable={false}
                      options={metricOptions}
                    />
                  }
                  <Select
                    className="reports-people-select-email"
                    placeholder="Filter by email..."
                    value={email}
                    onChange={this.handleEmailFilterChange}
                    options={this.makeEmailFilterOptions()}
                    isClearable={false}
                  />
                </Span>
              </Div>
            </Div>
            {this.renderTableOrEmptyState()}
          </Fragment>
        }
        {hasLoaded &&
          <Paginator size={size} index={currentPage} totalPages={this.getNumPages()} changeSize={this.setPageSize} goForward={this.goToNext} goBackward={this.goToPrevious} />
        }
        {isUnenrolling &&
          <Modal
            open={ true }
            type="warning"
            size="small"
            onClose={this.onCancelClick}
            className="playbook-unenroll-modal"
            title={`Are you sure you want to unenroll ${unenrollingPerson ? unenrollingPerson.email: ''}?`}
            footerCopy={
              <>
               <Button
                  type="secondary"
                  size="medium"
                  onClick={() => this.onUnenrollClick(unenrollingPerson)}
                >
                  Unenroll
                </Button>
                <Button
                  type="tertiary"
                  onClick={this.onCancelClick}
                >
                  Cancel
                </Button>
              </>
            }
            >
            {pathOr('This person', ['name'], unenrollingPerson)} will no longer receive emails in this campaign. This action cannot be undone.
          </Modal>
        }
      </Div>
    )
  }
}

const mapStateToProps = state => ({
  currentUserId: pathOr(null, ['user', 'id'], state)
})

const mapDispatchToProps = dispatch => {
  return {
    notify: (message, type = 'success') => dispatch(showTransientNotification({ message, type }))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignPeopleTab)
